module.exports = __webpack_public_path__ + "static/media/amexIcon.a3c6d5a6.png";